<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ currentUser?.school?.logo }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ currentUser?.school?.name | uppercase }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block">
      <a type="button" class="nav-link nav-link-style btn" (click)="goBack()">
        <span class="icon-arrow-left ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->
  </div>

  <ul class="nav navbar-nav align-items-center ml-auto">

    <!-- Toggle skin -->
    <li class="nav-item d-none d-lg-block mr-1">
      <a type="button" class="nav-link nav-link-style btn" (click)="toggleDarkSkin()">
        <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
      </a>
    </li>
    <!--/ Toggle skin -->

    <!-- Context Dropdowns Group (Desktop/Tablet) -->
    <li class="nav-item dropdown-context-group d-none d-md-flex align-items-center">

      <!-- Academic Year Dropdown -->
      <div ngbDropdown class="dropdown-academic-year mr-75" *ngIf="isAdmin">
        <a class="nav-link dropdown-toggle d-flex align-items-center p-0" id="navbarAcademicYear" ngbDropdownToggle
          aria-haspopup="true">
          <div class="context-badge d-flex align-items-center">
            <span [data-feather]="'calendar'" class="context-icon"></span>
            <span class="context-text d-none d-lg-inline">
              {{ selectedAcademicYear?.name || ('COMMON.ACADEMIC_YEAR' | translate) }}
            </span>
            <span [data-feather]="'chevron-down'" class="dropdown-chevron"></span>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="navbarAcademicYear"
          class="dropdown-menu dropdown-menu-right context-dropdown">
          <h6 class="dropdown-header">{{ 'COMMON.SELECT_ACADEMIC_YEAR' | translate }}</h6>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scrollable">
            <a *ngFor="let year of academicYears" ngbDropdownItem (click)="switchAcademicYear(year)"
              [class.active]="year.id === selectedAcademicYear?.id" class="dropdown-context-item">
              <span [data-feather]="'calendar'" class="item-icon"></span>
              <span class="flex-grow-1">{{ year.name }}</span>
              <span *ngIf="year.is_active" class="badge badge-pill badge-light-success">
                {{ 'COMMON.ACTIVE' | translate }}
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- Semester Dropdown -->
      <div ngbDropdown class="dropdown-semester mr-75" *ngIf="isAdmin && semesters.length > 0">
        <a class="nav-link dropdown-toggle d-flex align-items-center p-0" id="navbarSemester" ngbDropdownToggle
          aria-haspopup="true">
          <div class="context-badge d-flex align-items-center">
            <span [data-feather]="'layers'" class="context-icon"></span>
            <span class="context-text d-none d-lg-inline">
              {{ selectedSemester?.name || ('COMMON.SEMESTER' | translate) }}
            </span>
            <span [data-feather]="'chevron-down'" class="dropdown-chevron"></span>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="navbarSemester"
          class="dropdown-menu dropdown-menu-right context-dropdown">
          <h6 class="dropdown-header">{{ 'COMMON.SELECT_SEMESTER' | translate }}</h6>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scrollable">
            <a *ngFor="let semester of semesters" ngbDropdownItem (click)="switchSemester(semester)"
              [class.active]="semester.id === selectedSemester?.id" class="dropdown-context-item">
              <span [data-feather]="'layers'" class="item-icon"></span>
              <span class="flex-grow-1">{{ semester.name }}</span>
              <span *ngIf="semester.is_current" class="badge badge-pill badge-light-primary">
                {{ 'COMMON.CURRENT' | translate }}
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- Sequence Dropdown -->
      <div ngbDropdown class="dropdown-sequence mr-75" *ngIf="isAdmin && sequences.length > 0">
        <a class="nav-link dropdown-toggle d-flex align-items-center p-0" id="navbarSequence" ngbDropdownToggle
          aria-haspopup="true">
          <div class="context-badge d-flex align-items-center">
            <span [data-feather]="'hash'" class="context-icon"></span>
            <span class="context-text d-none d-lg-inline">
              {{ selectedSequence?.name || ('COMMON.SEQUENCE' | translate) }}
            </span>
            <span [data-feather]="'chevron-down'" class="dropdown-chevron"></span>
          </div>
        </a>
        <div ngbDropdownMenu aria-labelledby="navbarSequence"
          class="dropdown-menu dropdown-menu-right context-dropdown">
          <h6 class="dropdown-header">{{ 'COMMON.SELECT_SEQUENCE' | translate }}</h6>
          <div class="dropdown-divider"></div>
          <div class="dropdown-scrollable">
            <a *ngFor="let sequence of sequences" ngbDropdownItem (click)="switchSequence(sequence)"
              [class.active]="sequence.id === selectedSequence?.id" class="dropdown-context-item">
              <span [data-feather]="'hash'" class="item-icon"></span>
              <span class="flex-grow-1">{{ sequence.name }}</span>
              <span *ngIf="sequence.is_current" class="badge badge-pill badge-light-info">
                {{ 'COMMON.CURRENT' | translate }}
              </span>
            </a>
          </div>
        </div>
      </div>

    </li>
    <!--/ Context Dropdowns Group (Desktop/Tablet) -->

    <!-- Mobile Context Dropdown (Combined) -->
    <li ngbDropdown class="nav-item dropdown-context-mobile d-md-none" *ngIf="isAdmin">
      <a class="nav-link dropdown-toggle d-flex align-items-center" id="navbarContextMobile" ngbDropdownToggle
        aria-haspopup="true">
        <div class="context-badge-mobile d-flex align-items-center">
          <span [data-feather]="'calendar'" class="context-icon"></span>
          <span [data-feather]="'chevron-down'" class="dropdown-chevron ml-25"></span>
        </div>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarContextMobile"
        class="dropdown-menu dropdown-menu-right context-dropdown-mobile">
        <!-- Academic Year Section -->
        <h6 class="dropdown-header">{{ 'COMMON.ACADEMIC_YEAR' | translate }}</h6>
        <a *ngFor="let year of academicYears" ngbDropdownItem (click)="switchAcademicYear(year)"
          [class.active]="year.id === selectedAcademicYear?.id" class="dropdown-context-item">
          <span [data-feather]="'calendar'" class="item-icon"></span>
          <span class="flex-grow-1">{{ year.name }}</span>
          <span *ngIf="year.is_active" class="badge badge-pill badge-light-success badge-sm">Active</span>
        </a>

        <!-- Semester Section -->
        <div *ngIf="semesters.length > 0">
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header">{{ 'COMMON.SEMESTER' | translate }}</h6>
          <a *ngFor="let semester of semesters" ngbDropdownItem (click)="switchSemester(semester)"
            [class.active]="semester.id === selectedSemester?.id" class="dropdown-context-item">
            <span [data-feather]="'layers'" class="item-icon"></span>
            <span class="flex-grow-1">{{ semester.name }}</span>
            <span *ngIf="semester.is_current" class="badge badge-pill badge-light-primary badge-sm">Current</span>
          </a>
        </div>

        <!-- Sequence Section -->
        <div *ngIf="sequences.length > 0">
          <div class="dropdown-divider"></div>
          <h6 class="dropdown-header">{{ 'COMMON.SEQUENCE' | translate }}</h6>
          <a *ngFor="let sequence of sequences" ngbDropdownItem (click)="switchSequence(sequence)"
            [class.active]="sequence.id === selectedSequence?.id" class="dropdown-context-item">
            <span [data-feather]="'hash'" class="item-icon"></span>
            <span class="flex-grow-1">{{ sequence.name }}</span>
            <span *ngIf="sequence.is_current" class="badge badge-pill badge-light-info badge-sm">Current</span>
          </a>
        </div>
      </div>
    </li>
    <!--/ Mobile Context Dropdown -->

    <!-- Language Switcher -->
    <li class="nav-item d-none d-sm-block mr-1">
      <app-language-switcher></app-language-switcher>
    </li>
    <!--/ Language Switcher -->

    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a class="nav-link dropdown-toggle dropdown-user-link" id="navbarUserDropdown" ngbDropdownToggle
        aria-haspopup="true">
        <div class="user-nav d-sm-flex d-none">
          <span class="user-name font-weight-bolder">
            {{ currentUser?.role?.name }}
          </span><span class="user-status">
            {{ currentUser?.school?.name }}
          </span>
        </div>
        <span class="avatar">
          <img class="round" [src]="currentUser?.profile_photo" alt="avatar" height="40" width="40" />
          <span class="avatar-status-online"></span></span>
      </a>
      <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
        <!--        <a ngbDropdownItem [routerLink]="['/app/admin/profile']">-->
        <!--          <span [data-feather]="'user'" [class]="'mr-50'">-->
        <!--          </span>-->
        <!--          Profile-->
        <!--        </a>-->
        <!-- <a ngbDropdownItem [routerLink]="['/']">
          <span [data-feather]="'mail'" [class]="'mr-50'"></span>
          Inbox
        </a>
        <a ngbDropdownItem [routerLink]="['/']">
          <span [data-feather]="'check-square'" [class]="'mr-50'"></span>
          Task
        </a> -->
        <a ngbDropdownItem [routerLink]="['/app/admin/settings']">
          <span [data-feather]="'settings'" [class]="'mr-50'"></span>
          Settings
        </a>
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()"><span [data-feather]="'power'" [class]="'mr-50'"></span>
          Logout</a>
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>